export default __webpack_public_path__ + "static/media/2_no_clouds_4k.825a0ecf.jpg";